/* eslint-disable func-names */
import { Injectable } from '@angular/core';
import { PlUtil } from '@common/pl-util';
import { Logger } from '@common/logger';

const log = new Logger('HeapLogger');

declare let globalThis: any;
@Injectable()
export class HeapLogger {
  user: any = null;

  constructor() {
    const heapKey = PlUtil.getEnvVar('heap_key', 'pl-heap-key');
    const fullStoryKey = PlUtil.getEnvVar('fullstory_key', 'pl-fullstory-key');
    const sentryKey = PlUtil.getEnvVar('sentry_dsn', 'pl-sentry-key');

    log.debug({ heapKey, fullStoryKey, sentryKey }, 'initHeap');

    if (heapKey) {
      this.loadHeap(heapKey);
    }

    if (fullStoryKey) {
      setTimeout(() => {
        if (globalThis.FS && globalThis.heap) {
          globalThis.heap.track('FullStory Session', {
            'Fullstory Session URL': globalThis.FS.getCurrentSessionURL(true),
          });
          globalThis.heap.addUserProperties({
            'Latest FullStory Session': globalThis.FS.getCurrentSessionURL(),
          });
        }
      }, 500);
    }
  }

  loadHeap(e: any, t?: any) {
    globalThis.heap = globalThis.heap || [];
    globalThis.heap.appid = e;
    const t2 = t || {};
    globalThis.heap.config = t2;

    const r = t2.forceSSL || document.location.protocol === 'https:';
    const a = document.createElement('script');
    a.type = 'text/javascript';
    a.async = !0;
    a.src = `${r ? 'https:' : 'http:'}//cdn.heapanalytics.com/js/heap-${e}.js`;

    const n = document.getElementsByTagName('script')[0];
    n.parentNode.insertBefore(a, n);

    const o = function (f: any) {
      return function (...args: any) {
        globalThis.heap.push([f].concat(Array.prototype.slice.call(args, 0)));
      };
    };
    const p = [
      'addEventProperties',
      'addUserProperties',
      'clearEventProperties',
      'identify',
      'removeEventProperty',
      'setEventProperties',
      'track',
      'unsetEventProperty',
    ];
    for (let c = 0; c < p.length; c += 1) {
      globalThis.heap[p[c]] = o(p[c]);
    }

    if (globalThis.heap) {
      globalThis.heap.addEventProperties({
        version: PlUtil.getEnvVar('git_sha'),
      });
      globalThis.addEventListener('error', (event: any) => {
        const { error } = event;
        this.handleError('console-error', error);
      });
    }
  }

  handleError(context: string, error: any) {
    if (!globalThis.heap) return;
    globalThis.heap.track('error', { context, error });
  }

  setUser(user: any) {
    if (user) {
      const userGroups = user.groups ? user.groups.join('+') : 'no-groups';
      this.user = user;
      if (globalThis.heap && user.username) {
        globalThis.heap.identify(this.user.username);
        globalThis.heap.addUserProperties({
          email: this.user.email,
          uuid: this.user.uuid,
          groups: userGroups,
        });
      }
      if (globalThis.FS && user.username) {
        globalThis.FS.setUserVars({
          uid: this.user.uuid,
          email: this.user.email,
          displayName: `${this.user.first_name} ${this.user.last_name}`,
          groups: userGroups,
        });
      }
    }
  }

  setIsHijacked(val: boolean) {
    if (globalThis.heap) {
      globalThis.heap.addUserProperties({
        hijacked: val,
      });
    }
  }

  logCustomEvent(name: string, data: any) {
    if (globalThis.heap) {
      globalThis.heap.track(name, data);
    }
  }
}
